import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import Buscador from './screens/Buscador';
import Resultados from './screens/Resultados';
import DetalleRegistro from './screens/DetalleRegistro';
import './App.css';

import 'primereact/resources/themes/md-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const App: React.FC = () => {
  return <>
    <Router>
      <Switch>
        <Route path="/detalle">
          <DetalleRegistro />
        </Route>
        <Route path="/resultados">
          <Resultados />
        </Route>
        <Route path="/">
          <Buscador />
        </Route>
      </Switch>
    </Router>
  </>
}

export default App;
